import { render } from "./WorkflowAggregatesAICode.vue?vue&type=template&id=1288b538&scoped=true"
import script from "./WorkflowAggregatesAICode.vue?vue&type=script&lang=js"
export * from "./WorkflowAggregatesAICode.vue?vue&type=script&lang=js"

import "./WorkflowAggregatesAICode.vue?vue&type=style&index=0&id=1288b538&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1288b538"]])

export default __exports__